import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { TEntityGridConstraints } from 'app/common/entity-grid/core';
import * as EntityGrid from 'app/common/entity-grid/features';
import { HotFixEntityGridReadRequest } from 'app/common/entity-grid/features/entity-grid';
import { useUserRoles } from 'app/railways/domains/access/features/roles/use-user-roles';

import { getTerminalsRequest } from '../../requests';
import { cols } from './terminal-entity-grid-columns';

export const TerminalEntityGrid = observer(() => {
  const userRoles = useUserRoles();

  const initialConstraints = useMemo<TEntityGridConstraints>(
    () => ({
      sorting: [{ name: 'id', direction: 'descend' }],
    }),
    [],
  );

  return (
    <EntityGrid.Root
      columns={cols}
      rowModelType="largeList"
      recordsLimit={1000}
      initialState={initialConstraints}
      request={getTerminalsRequest}
      userRoles={userRoles}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          padding: 16,
          height: '100%',
        }}
      >
        <EntityGrid.NotificationsRender>
          {(notifications) => <div>{notifications}</div>}
        </EntityGrid.NotificationsRender>

        <HotFixEntityGridReadRequest />

        <div style={{ flexGrow: 1 }}>
          <EntityGrid.Table
            rowSelection="multiple"
            persistSettingsId="TripsOrdersEntityGrid"
            autoSizeStrategy={{ type: 'fitGridWidth' }}
            onModelUpdated={(event) => event.api.sizeColumnsToFit()}
          />
        </div>
      </div>
    </EntityGrid.Root>
  );
});
